import { Theme, css } from '@emotion/react';

const supplementCompactCssDefs = {
  name: css`
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  `,
  description: css`
    margin-top: 4px;
    // utilizing webkit for now to accomplish multi-line truncation, may need to replace eventually with a generic
    // see: https://css-tricks.com/almanac/properties/l/line-clamp/ for most up to date truncation methods
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    line-clamp: 2;
    overflow: hidden;
  `,
  contentFooter: css`
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
  `,
  spaceLeft: ({ spacing }: Theme) => css`
    margin-left: ${spacing(1)}px;
  `,
};

export default supplementCompactCssDefs;
